"use client";
import React from "react";
import { cj } from "../utils";
import { BgVideoContext } from "./shared/bgVideoContext";
const BackgroundVideoPlayPauseButton = /*#__PURE__*/ React.forwardRef(function BackgroundVideoPlayPauseButton({ children, className }, ref) {
    const { togglePlay } = React.useContext(BgVideoContext);
    return /*#__PURE__*/ React.createElement("div", {
        "aria-live": "polite"
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: cj(className, "w-backgroundvideo-backgroundvideoplaypausebutton", "w-background-video--control"),
        onClick: togglePlay,
        ref: ref
    }, children));
});
export default BackgroundVideoPlayPauseButton;
